import { API } from '@Providers';
import type { AddProductToOutcomeCartRequestPayload } from '../types';

export default async function (payload: AddProductToOutcomeCartRequestPayload) {
  const endpoint = '/api/shelter/products/add-to-outcome-cart';

  return API({ endpoint, method: 'post', payload });
}
